import styled from "styled-components";
import {SharedColors} from "@dropDesk/domain/entities/theme/app_colors";

type ContainerType = {
    background: string;
};

type BoxType = {
    background: string;
    color: string;
};

type TextType = {
    color: string;
};

export const ContainerModal = styled.div<ContainerType>`
    display: flex;
    background: ${(props) => props.background};
    flex: 1;
    flex-direction: column;
    border-radius: 5px;
`;

export const ContainerSubTitle = styled.div<TextType>`
    display: flex;
    flex-direction: row;
    width: 100%;
    font-size: 16px;
    color: ${props => props.color};
    padding: 0 16px;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
`;

export const Content = styled.div<ContainerType>`
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 16px;
    margin: 0 8px 8px 8px;
    background: ${(props) => props.background};
    max-height: calc(100vh - 165px);
    overflow: auto;
`;


export const ContainerBox = styled.div<BoxType>`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 50px;
    background: ${(props) => props.background};
    border-radius: 5px;
    padding: 0 16px;
    font-size: 18px;
    color: ${props => props.color};
    justify-content: center;
    margin-bottom: 12px;
    text-transform: uppercase;
`;

export const TextEllipsis = styled.div`
    display: block;
    max-width: 552px !important;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    white-space: nowrap;
`;